import { render, staticRenderFns } from "./StampaOdr.vue?vue&type=template&id=74f7fadd&scoped=true"
import script from "./StampaOdr.vue?vue&type=script&lang=js"
export * from "./StampaOdr.vue?vue&type=script&lang=js"
import style0 from "./StampaOdr.vue?vue&type=style&index=0&id=74f7fadd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f7fadd",
  null
  
)

export default component.exports